import React, { Component } from "react";
import { Spin, Modal, Row, Col, Button, Table } from "antd";
import moment from "moment";
import {
  showErrorNotification,
  strings,
  showSuccessNotification
} from "../../helpers";
import NewsFeedListView from "./NewsFeedListView";
import NewsFeedForm from "./NewsFeedForm";
import {
  deleteNewsArticle,
  getNewsTags,
  getNewsArticlesList,
  newsArticlePublish,
  getPresignedUrl,
  uploadImageToS3,
  getRssFeed,
  createWeeklyNews
} from "../../services";
import ReactDragListView from "react-drag-listview";

const confirm = Modal.confirm;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default class NewsFeedListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessing: false,
      totalRecords: 0,
      totalPage: 0,
      pageNo: 1,
      searchText: "",
      showAddModal: false,
      selectedRecord: null,
      newsImageArray: [],
      thumbnailImageArray: [],
      ImgPhotoUrl: null,
      sourceThumbnailUrl: null,
      previewVisible: false,
      previewImage: "",
      fileList: [],
      thumbnailPreviewImage: "",
      thumbnailPreviewVisible: false,
      selectedRowKeys: [], // Check here to configure the default column
      loading: false,
      tags: [],
      suggestions: [],
      newsArticleList: [],
      editField: false,
      publishStatus: null,
      searchByTag: [],
      tagIds: "",
      selectedSpecialities: [],
      city: null,
      address: null,
      newsType: null,
      showAddDescModal: false,
      newsDesc: null,
      perPage: 10,
      startDate: null,
      endDate: null,
      showWeeklyNewsModal: false,
      selectedWeeklyNews: []
    };
  }

  componentDidMount() {
    this.getNewsTagsList();
    this.getArticlesList();
  }

  /**
   * @function getNewsTagsList
   * @description this will show tag list
   */
  getNewsTagsList = () => {
    getNewsTags().then(response => {
      const renamedArray = response.data.data.news_tags.map(obj => {
        return { id: obj.id, name: obj.tag_name };
      });
      this.setState({ suggestions: renamedArray });
    });
  };

  /**
   * @function getArticlesList
   * @description it will show news article list
   */
  getArticlesList = () => {
    const {
      pageNo,
      searchText,
      publishStatus,
      tagIds,
      newsType,
      perPage,
      startDate,
      endDate
    } = this.state;
    this.setState({
      isProcessing: true
    });
    const startDateFilter = startDate
      ? moment(startDate)
          .startOf("day")
          .utc()
          .format()
      : null;
    const endDateFilter = endDate
      ? moment(endDate)
          .endOf("day")
          .utc()
          .format()
      : null;
    getNewsArticlesList(
      pageNo,
      searchText,
      publishStatus,
      tagIds,
      newsType,
      perPage,
      startDateFilter,
      endDateFilter
    )
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response?.data?.data?.length > 0) {
          const newsArray = response.data.data;
          const allNews = [];
          newsArray.map(obj => {
            allNews.push(obj.attributes);
          });
          const { total_records } = response.data.meta;
          const { total_pages } = response.data.meta;
          this.setState({
            newsArticleList: allNews,
            totalRecords: total_records,
            totalPages: total_pages
          });
        } else {
          this.setState({
            newsArticleList: [],
            isProcessing: false,
            totalRecords: 0,
            totalPages: 0
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ newsArticleList: [], isProcessing: false });
      });
  };
  /**
   * @function onDelete
   * @description it will delete tag
   */

  onDelete = i => {
    const tags = this.state.tags.slice(0);
    tags.splice(i, 1);
    this.setState({ tags });
  };

  /**
   * @function onAddition
   * @description it will add tag
   */
  onAddition = tag => {
    const tags = [].concat(this.state.tags, tag);
    this.setState({ tags });
  };

  /**
   * @function onSearchTagAddition
   * @description it will add tag
   */
  onSearchTagAddition = tag => {
    const tags = [].concat(this.state.searchByTag, tag);
    const searchTags = tags.map(item => item.id).join();
    this.setState({ searchByTag: tags, tagIds: searchTags, pageNo: 1 }, () => {
      this.getArticlesList();
    });
  };

  /**
   * @function onSearchTagDelete
   * @description it will delete tag
   */

  onSearchTagDelete = i => {
    const tags = this.state.tags.slice(0);
    tags.splice(i, 1);
    this.setState({ searchByTag: tags, tagIds: "" }, () => {
      this.getNewsTagsList();
      this.getArticlesList();
    });
  };

  /**
   * @function showAddModal
   * @description it will show the modal
   */
  toggleAddModal = () => {
    const { showAddModal } = this.state;
    this.setState({
      showAddModal: !showAddModal,
      selectedRecord: {},
      fileList: [],
      thumbnailImageArray: [],
      tags: [],
      editField: false
    });
  };

  /**
   * @function deleteSelectedArticle
   * @description This function will delete selected article
   */
  deleteSelectedArticle = id => {
    const _this = this;
    confirm({
      okText: "Delete",
      title: "Are you sure you want to delete the selected news article?",
      content: "",
      onOk() {
        _this.setState({ isProcessing: true });
        deleteNewsArticle(id)
          .then(response => {
            _this.setState({
              isProcessing: false
            });
            if (response.data.success) {
              showSuccessNotification("News Article deleted successfully.");
              _this.getArticlesList();
            } else {
              _this.setState({
                isProcessing: false
              });
            }
          })
          .catch(() => {
            showErrorNotification(strings.error_msg);
            _this.setState({ newsArticleList: [], isProcessing: false });
          });
      },
      onCancel() {}
    });
  };

  /**
   * @function toggleIsProcessing
   * @description it will change the processing.
   */
  toggleIsProcessing = () => {
    const { isProcessing } = this.state;
    this.setState({ isProcessing: !isProcessing });
  };

  /**
   * @function stopIsProcessing
   * @description it will change the processing.
   */
  stopIsProcessing = () => {
    this.setState({ isProcessing: false });
  };

  /**
   * @function editNewsArticleForm
   * @description this will edit modal article.
   */

  editNewsArticleForm = (selectedRecord, selectedId) => {
    const fileList = [];
    const thumbnailImageArray = [];
    let newsImgObj = null;

    if (selectedRecord.photo_url) {
      newsImgObj = {
        uid: "1",
        status: "done",
        url: selectedRecord.photo_url
      };
      fileList.push(newsImgObj);
    }

    if (selectedRecord.source_thumbnail_url) {
      const thumbnailImgObj = {
        uid: "2",
        status: "done",
        url: selectedRecord.source_thumbnail_url
      };
      thumbnailImageArray.push(thumbnailImgObj);
    }

    const tags = selectedRecord.news_tags;

    let renamedArray = [];
    if (tags.length > 0) {
      renamedArray = tags.map(obj => {
        return { id: obj.id, name: obj.tag_name };
      });
    }

    this.setState(
      {
        fileList,
        thumbnailImageArray,
        tags: renamedArray,
        editField: true,
        ImgPhotoUrl: selectedRecord.photo_url,
        sourceThumbnailUrl: selectedRecord.source_thumbnail_url,
        selectedSpecialities: selectedRecord.basic_clinic_specialities
          ? selectedRecord.basic_clinic_specialities
          : [],
        city: selectedRecord.city
      },
      () => {
        this.setState({ showAddModal: true, selectedRecord });
      }
    );
  };

  /**
   * @func customRequest
   * @param file
   * @param onProgress
   * @desc it makes the request to upload image
   */
  ImagecustomRequest = async ({ file, onProgress }) => {
    this.setState({ uploading: true });
    const uniqueTimeStamp = new Date().getTime();
    const keyValue = `${process.env.REACT_APP_NEWS_IMAGES_S3_FOLDER}/news/${uniqueTimeStamp}_${file.name}`;

    const params = {
      files: [
        {
          bucket: process.env.REACT_APP_S3_BUCKET,
          file_path: keyValue
        }
      ]
    };

    let response = await getPresignedUrl(params);
    let fileUrl = null;

    if (response && response.data && response.data.success) {
      fileUrl = response.data.data.ps_urls[0];
      const uploadResponse = await uploadImageToS3(fileUrl, file.type, file);
      if (uploadResponse && uploadResponse.status === 200) {
        const uploadedS3FileUrl = `https://${process.env.REACT_APP_S3_BUCKET}.s3.${process.env.REACT_APP_S3_REGION}.amazonaws.com/${keyValue}`;

        this.setState({ uploading: false, ImgPhotoUrl: uploadedS3FileUrl });
      }
    }
  };

  /**
   * @func thumbnailCustomRequest
   * @param file
   * @param onProgress
   * @desc it makes the request to upload image
   */
  thumbnailCustomRequest = async ({ file, onProgress }) => {
    this.setState({ uploading: true });

    const uniqueTimeStamp = new Date().getTime();

    const keyValue = `${process.env.REACT_APP_NEWS_IMAGES_S3_FOLDER}/source/${uniqueTimeStamp}_${file.name}`;

    const params = {
      files: [
        {
          bucket: process.env.REACT_APP_S3_BUCKET,
          file_path: keyValue
        }
      ]
    };

    let response = await getPresignedUrl(params);
    let fileUrl = null;

    if (response && response.data && response.data.success) {
      fileUrl = response.data.data.ps_urls[0];
      const uploadResponse = await uploadImageToS3(fileUrl, file.type, file);
      if (uploadResponse && uploadResponse.status === 200) {
        const uploadedS3FileUrl = `https://${process.env.REACT_APP_S3_BUCKET}.s3.${process.env.REACT_APP_S3_REGION}.amazonaws.com/${keyValue}`;

        this.setState({
          uploading: false,
          sourceThumbnailUrl: uploadedS3FileUrl
        });
      }
    }
  };

  /**
   * @func handleImageChange
   * @param fileList
   * @desc it returns all the data of images
   */
  handleImageChange = data => {
    if (!this.state.maxLimitReached) {
      const { fileList, file } = data;
      const { status } = file;
      const forApiArray = [];

      this.setState({ fileList, status }, () => {
        fileList.map(element => {
          const forApi = {
            id: element.id,
            photo_url: element.url,
            cover_photo: element.cover_photo || false,
            url: element.url
          };
          forApiArray.push(forApi);
        });
        this.setState({ newsImageArray: forApiArray });
      });
    }
  };

  /**
   * @func handlePreview
   * @param file
   * @desc it shows the image preview
   *
   */
  handleImagePreview = file => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true
    });
  };

  /**
   * @func handleCancel
   * @param
   * @desc it will cancel image preview
   *
   */
  handleCancel = () => this.setState({ previewVisible: false });

  /**
   * @func handlePreview
   * @param file
   * @desc it will handle image preview
   *
   */
  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true
    });
  };

  /**
   * @func handleChange
   * @param data
   * @desc it will handle photo img on change
   *
   */
  handleChange = data => {
    if (data.fileList.length === 0) {
      this.setState({ ImgPhotoUrl: null });
    }
    if (data.fileList.length > 0) {
      data.fileList[0].status = "done";
    }
    this.setState({ fileList: data.fileList });
  };

  /**
   * @func handlethumbnailPhotoCancel
   * @desc this function close the image modal
   */
  handlethumbnailPhotoCancel = () =>
    this.setState({ previewVisible: false, thumbnailPreviewVisible: false });

  /**
   * @func handleThumbnailPreview
   * @param file
   * @desc this function handle thumbnail image preview
   *
   */
  handleThumbnailPreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      thumbnailPreviewImage: file.url || file.preview,
      thumbnailPreviewVisible: true
    });
  };

  /**
   * @func handleThumbnailPhotoChange
   * @param data
   * @desc this function handle thumnail upload image
   *
   */

  handleThumbnailPhotoChange = data => {
    if (data.fileList.length === 0) {
      this.setState({ sourceThumbnailUrl: null });
    }
    if (data.fileList.length > 0) {
      data.fileList[0].status = "done";
    }
    this.setState({ thumbnailImageArray: data.fileList });
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys, selectedWeeklyNews: selectedRows });
  };

  /**
   * @func moveToArticleUrl
   * @param record
   * @desc this will move the article url page on web
   *
   */
  moveToArticleUrl = (e, record) => {
    e.preventDefault();
    window.open(record.source_link, "_blank");
  };

  /**
   * @function handleSearchText
   * @description This function get called when press enter on search text
   */
  handleSearchText = e => {
    this.setState({ searchText: e.target.value });
  };

  /**
   * @function handleDescChange
   * @description This function get called when clicked on pres button
   */
  handleDescChange = value => {
    this.setState({ newsDesc: value });
  };

  /**
   * @function handleSearch
   * @description This function get called when clicked on pres button
   */
  handleSearch = () => {
    this.setState({ pageNo: 1, newsArticleList: [] }, () => {
      this.getArticlesList();
    });
  };

  /**
   * @function togglePublishDescModal
   * @description This function get called on publish click
   */
  togglePublishDescModal = () => {
    this.setState({
      showAddDescModal: !this.state.showAddDescModal
    });
  };

  /**
   * @function requestArticlePublish
   * @description This function will publish article when clicked on publish button
   */
  requestArticlePublish = () => {
    const { selectedRowKeys, newsDesc } = this.state;

    this.setState({ isProcessing: true, showAddDescModal: false });
    newsArticlePublish(selectedRowKeys, newsDesc)
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response.data.success) {
          showSuccessNotification("Selected Article published successfully.");
          this.setState({ selectedRowKeys: [], newsDesc: null });
          this.getArticlesList();
        } else {
          this.setState({
            isProcessing: false
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ newsArticleList: [], isProcessing: false });
      });
  };

  /**
   * @function onPageChange
   * @param page
   * @description This function get called on page change
   */
  onPageChange = page => {
    this.setState({ pageNo: page, newsArticleList: [] }, () => {
      this.getArticlesList();
    });
  };

  /**
   * @function handleSearchByPublishStatus
   * @param value
   * @description This function return the record with publish status
   */
  handleSearchByPublishStatus = value => {
    const { publishStatus } = this.state;
    if (value === "yes") {
      this.setState({ publishStatus: "true" }, () => {
        this.getArticlesList();
      });
    } else if (value === "No") {
      this.setState({ publishStatus: "false" }, () => {
        this.getArticlesList();
      });
    } else {
      this.setState({ publishStatus: null }, () => {
        this.getArticlesList();
      });
    }
  };

  /**
   * @function resetFormData
   * @description This function handles resetting form relates state values
   */
  resetFormData = () => {
    this.setState({
      fileList: [],
      thumbnailImageArray: [],
      tags: [],
      editField: false,
      ImgPhotoUrl: null,
      sourceThumbnailUrl: null,
      selectedRecord: null,
      city: null,
      address: null,
      selectedSpecialities: []
    });
  };

  onSpecDelete = i => {
    const tags = this.state.selectedSpecialities.slice(0);
    tags.splice(i, 1);
    this.setState({ selectedSpecialities: tags });
  };

  onSpecAddition = tag => {
    const tags = [].concat(this.state.selectedSpecialities, tag);
    this.setState({ selectedSpecialities: tags });
  };

  /**
   * @function setCity
   * @param city
   * @desc This method updates the location variables in state variables
   */
  setCity = location => {
    if (location.city && location.city.trim().length > 0) {
      this.setState({
        city: location.city,
        state: location.state
      });
    } else {
      this.setState({
        city: null,
        state: null
      });
    }
  };

  /**
   * @function handleCityChange
   * @param address
   * @desc This method will be called when user types in autoplaces city box.
   *       It updates the city and address state variables
   */
  handleCityChange = address => {
    this.setState({ city: address, address });
  };

  handleFilterNewsType = filterType => {
    let newsType = filterType;
    if (filterType == "ALL") newsType = null;
    this.setState({ newsType }, () => this.getArticlesList());
  };

  handleFetchRssFeed = () => {
    getRssFeed().then(response => {
      if (response?.data?.success) {
        showSuccessNotification(
          "Rss feed enqueued successfully. Please refresh news list after sometime."
        );
      } else {
        showErrorNotification("Please try after some time.");
      }
    });
  };

  handleChangePageSizeChange = (current, size) => {
    this.setState({ perPage: size, pageNo: 1 }, () => {
      this.getArticlesList();
    });
  };

  onDateFilterSelect = (date, dateString) => {
    const dateToday = moment(new Date()).format("YYYY-MM-DD");
    if (date?.length > 0) {
      const startDate = date[0] || dateToday;
      const endDate = date[1] || dateToday;
      this.setState({ startDate, endDate }, () => {
        this.getArticlesList();
      });
    } else {
      this.setState(
        {
          startDate: null,
          endDate: null
        },
        () => {
          this.getArticlesList();
        }
      );
    }
  };

  handlePrepareWeeklyNews = () => {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length < 1)
      showErrorNotification("Please select atleast 1 article");
    else if (selectedRowKeys.length > 10)
      showErrorNotification("Maximum 10 articles allowed.");
    else this.setState({ showWeeklyNewsModal: true });
  };

  toggleWeeklyModal = showBoolean => {
    this.setState({ showWeeklyNewsModal: showBoolean });
  };

  saveWeeklyNews = () => {
    const { selectedWeeklyNews } = this.state;
    const newsArticles = [];
    selectedWeeklyNews.map((article, index) => {
      newsArticles.push({
        id: article?.id,
        sequence: index + 1
      });
    });
    this.setState({ isProcessing: true });
    const params = {
      news_articles: newsArticles
    };
    createWeeklyNews(params)
      .then(response => {
        if (response?.data?.success) {
          this.setState({ selectedWeeklyNews: [] });
          this.toggleWeeklyModal(false);
          showSuccessNotification("Weekly news list created successfully");
        } else {
          showErrorNotification(strings.error_msg);
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  render() {
    const {
      isProcessing,
      totalRecords,
      totalPages,
      pageNo,
      searchText,
      showAddModal,
      selectedRecord,
      ImgPhotoUrl,
      newsImageArray,
      previewVisible,
      previewImage,
      fileList,
      thumbnailPreviewImage,
      thumbnailPreviewVisible,
      thumbnailImageArray,
      sourceThumbnailUrl,
      loading,
      selectedRowKeys,
      tags,
      suggestions,
      newsArticleList,
      editField,
      totalPage,
      searchByTag,
      selectedSpecialities,
      city,
      address,
      showAddDescModal,
      newsDesc,
      perPage,
      startDate,
      endDate,
      showWeeklyNewsModal,
      selectedWeeklyNews
    } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    };
    const hasSelected = selectedRowKeys.length > 0;

    const weeklyColumns = [
      {
        title: "News Heading",
        key: "news_heading",
        align: "left",
        width: 250,
        render: record => (
          <div className="news-article-heading">
            {record.news_type === "CME" ? record.event_name : record.title}
          </div>
        )
      },
      {
        title: "Sequence action",
        key: "operate",
        render: (text, record, index) => (
          <a className="drag-handle" href="#">
            Drag
          </a>
        )
      }
    ];

    const that = this;
    const dragProps = {
      onDragEnd(fromIndex, toIndex) {
        const data = [...that.state.selectedWeeklyNews];
        const item = data.splice(fromIndex, 1)[0];
        data.splice(toIndex, 0, item);
        that.setState({ selectedWeeklyNews: data });
      },
      lineClassName: "primary-colored-line",
      handleSelector: "a"
    };

    return (
      <Spin spinning={isProcessing}>
        <NewsFeedListView
          editNewsArticleForm={this.editNewsArticleForm}
          deleteSelectedArticle={this.deleteSelectedArticle}
          toggleAddModal={this.toggleAddModal}
          allRecords={totalRecords}
          allPages={totalPages}
          pageNo={pageNo}
          onPageChange={this.onPageChange}
          searchText={searchText}
          handleSearchText={this.handleSearchText}
          handleSearch={this.handleSearch}
          handleFilterBy={this.handleFilterBy}
          rowSelection={rowSelection}
          hasSelected={hasSelected}
          loading={loading}
          newsArticleList={newsArticleList}
          moveToArticleUrl={this.moveToArticleUrl}
          requestArticlePublish={this.requestArticlePublish}
          handleSearchByPublishStatus={this.handleSearchByPublishStatus}
          searchByTag={searchByTag}
          suggestions={suggestions}
          onSearchTagAddition={this.onSearchTagAddition}
          onSearchTagDelete={this.onSearchTagDelete}
          handleFilterNewsType={this.handleFilterNewsType}
          togglePublishDescModal={this.togglePublishDescModal}
          showAddDescModal={showAddDescModal}
          newsDesc={newsDesc}
          handleDescChange={this.handleDescChange}
          handleFetchRssFeed={this.handleFetchRssFeed}
          handleChangePageSizeChange={this.handleChangePageSizeChange}
          perPage={perPage}
          startDate={startDate}
          endDate={endDate}
          onDateFilterSelect={this.onDateFilterSelect}
          isProcessing={isProcessing}
          selectedRowKeys={selectedRowKeys}
          handlePrepareWeeklyNews={this.handlePrepareWeeklyNews}
        />
        {showAddModal && (
          <NewsFeedForm
            selectedRecord={selectedRecord}
            stopIsProcessing={this.stopIsProcessing}
            toggleIsProcessing={this.toggleIsProcessing}
            showAddModal={showAddModal}
            toggleAddModal={this.toggleAddModal}
            ImagecustomRequest={this.ImagecustomRequest}
            handleImagePreview={this.handleImagePreview}
            handleImageChange={this.handleImageChange}
            ImgPhotoUrl={ImgPhotoUrl}
            newsImageArray={newsImageArray}
            previewVisible={previewVisible}
            previewImage={previewImage}
            fileList={fileList}
            handleCancel={this.handleCancel}
            handlePreview={this.handlePreview}
            handleChange={this.handleChange}
            thumbnailCustomRequest={this.thumbnailCustomRequest}
            thumbnailPreviewImage={thumbnailPreviewImage}
            thumbnailPreviewVisible={thumbnailPreviewVisible}
            handlethumbnailPhotoCancel={this.handlethumbnailPhotoCancel}
            handleThumbnailPreview={this.handleThumbnailPreview}
            handleThumbnailPhotoChange={this.handleThumbnailPhotoChange}
            thumbnailImageArray={thumbnailImageArray}
            sourceThumbnailUrl={sourceThumbnailUrl}
            isProcessing={isProcessing}
            selectedRowKeys={selectedRowKeys}
            loading={loading}
            tags={tags}
            suggestions={suggestions}
            onAddition={this.onAddition}
            onDelete={this.onDelete}
            newsArticleList={newsArticleList}
            editField={editField}
            searchText={searchText}
            totalPage={totalPage}
            totalRecords={totalRecords}
            getArticlesList={this.getArticlesList}
            getNewsTagsList={this.getNewsTagsList}
            resetFormData={this.resetFormData}
            selectedSpecialities={selectedSpecialities}
            onSpecDelete={this.onSpecDelete}
            onSpecAddition={this.onSpecAddition}
            city={city}
            setCity={this.setCity}
            handleCityChange={this.handleCityChange}
            address={address}
          />
        )}

        <Modal
          visible={showWeeklyNewsModal}
          title="Add description to publish notification"
          footer={null}
          onCancel={() => this.toggleWeeklyModal(false)}
          className="form-type-modal"
        >
          <div>
            <ReactDragListView {...dragProps}>
              <Table
                columns={weeklyColumns}
                pagination={false}
                dataSource={this.state.selectedWeeklyNews}
              />
            </ReactDragListView>

            <Row type="flex" gutter={8} className="mt-10">
              <Col>
                <Button type="primary" onClick={this.saveWeeklyNews}>
                  Update sequence
                </Button>
              </Col>
              <Col>
                <Button onClick={() => this.toggleWeeklyModal(false)}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </div>
        </Modal>
      </Spin>
    );
  }
}
